import { useState, useEffect } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { Calendar, AlertCircle } from 'lucide-react';
import { toast } from 'sonner';
import { HtmlContent } from '../components/RichTextEditor';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export default function Duyurular() {
  const [announcements, setAnnouncements] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchAnnouncements();
  }, []);

  const fetchAnnouncements = async () => {
    try {
      const response = await fetch(`${BACKEND_URL}/api/announcements`);
      const data = await response.json();
      setAnnouncements(data);
    } catch (error) {
      toast.error('Duyurular yüklenirken hata oluştu');
    } finally {
      setLoading(false);
    }
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('tr-TR', { 
      year: 'numeric', 
      month: 'long', 
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-gradient-to-b from-amber-50 to-white flex items-center justify-center">
        <div className="text-xl text-amber-800">Yükleniyor...</div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-b from-amber-50 to-white py-12">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12 fade-in">
          <h1 className="text-4xl sm:text-5xl font-bold text-amber-900 mb-4" style={{ fontFamily: 'Merriweather, serif' }}>
            Duyurular
          </h1>
          <p className="text-lg text-amber-700">
            Önemli duyuru ve bilgilendirmeler
          </p>
        </div>

        {announcements.length === 0 ? (
          <Card className="border-2 border-amber-200 bg-white">
            <CardContent className="p-12 text-center">
              <p className="text-lg text-amber-700">Henüz duyuru yayınlanmamış</p>
            </CardContent>
          </Card>
        ) : (
          <div className="space-y-6">
            {announcements.map((item) => (
              <Card key={item.id} className="card-hover border-l-4 border-l-orange-600 border-2 border-amber-200 bg-white" data-testid={`announcement-card-${item.id}`}>
                <CardHeader>
                  <div className="flex items-start gap-4">
                    <div className="flex-shrink-0 w-12 h-12 bg-gradient-to-br from-orange-600 to-amber-600 rounded-full flex items-center justify-center">
                      <AlertCircle className="w-6 h-6 text-white" />
                    </div>
                    <div className="flex-1">
                      <CardTitle className="text-amber-900 text-2xl" style={{ fontFamily: 'Merriweather, serif' }}>
                        {item.title}
                      </CardTitle>
                      <div className="flex items-center gap-2 text-sm text-amber-600 mt-2">
                        <Calendar className="w-4 h-4" />
                        <span>{formatDate(item.created_at)}</span>
                      </div>
                    </div>
                  </div>
                </CardHeader>
                <CardContent>
                  <HtmlContent html={item.content} className="text-amber-800 leading-relaxed" />
                </CardContent>
              </Card>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
